import { render, staticRenderFns } from "./bindHouse.vue?vue&type=template&id=0f5d5c66&"
import script from "./bindHouse.vue?vue&type=script&lang=js&"
export * from "./bindHouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f5d5c66')) {
      api.createRecord('0f5d5c66', component.options)
    } else {
      api.reload('0f5d5c66', component.options)
    }
    module.hot.accept("./bindHouse.vue?vue&type=template&id=0f5d5c66&", function () {
      api.rerender('0f5d5c66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/unitManager/bindHouse.vue"
export default component.exports